export const SIDEBAR_ACTION_HOVER_GROUP = 'sidebar-action';

export const SIDEBAR_ACTION_GROUP_CLASSNAME = `group/${SIDEBAR_ACTION_HOVER_GROUP}`;

export const SIDEBAR_ACTION_ICON_HOVER_CLASSNAME =
  `transition-colors group-hover/${SIDEBAR_ACTION_HOVER_GROUP}:text-[var(--scribane-green)]`;

export const SIDEBAR_ACTION_LABEL_HOVER_CLASSNAME =
  `transition-colors group-hover/${SIDEBAR_ACTION_HOVER_GROUP}:text-[var(--scribane-green)]`;
